import assign from "lodash/fp/assign";
import apis from "../../core/apis.js";

class ContractorResource {
  constructor($resource, Upload) {
    "ngInject";

    this.$resource = $resource;
    this.Upload = Upload;
  }

  search(query = "", params) {
    return this.$resource(apis.contractors + "autocomplete/").get(
      assign(params, { query })
    );
  }

  get(id) {
    return this.$resource(apis.contractors + id).get();
  }

  getPaymentMethods(id, params) {
    return this.$resource(apis.contractors + id + "/payment_methods").query(
      params
    );
  }

  updatePaymentMethods(id, item) {
    return this.$resource(apis.contractors + id + "/payment_methods", null, {
      update: { method: "PATCH", isArray: true },
    }).update(item);
  }

  update(id, item) {
    return this.$resource(apis.contractors + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  uploadDocument(data, contractorResourceId) {
    const url = apis.contractors + contractorResourceId + "/upload_document";
    const request = this.Upload.upload({
      method: "POST",
      url,
      data,
    });
    return { $promise: request };
  }

  updateDocument(data, contractorResourceId) {
    return this.$resource(apis.contractors + contractorResourceId, null, {
      update: { method: "PATCH" },
    }).update(data);
  }

  addManagers(id, managers) {
    return this.$resource(apis.contractors + id + "/managers", null, {
      update: { method: "PUT" },
    }).update(managers);
  }

  deleteManagers(id, managers) {
    return this.$resource(apis.contractors + id + "/managers", null, {
      delete: { method: "DELETE", data: managers },
    }).delete();
  }
}

export default ContractorResource;



// WEBPACK FOOTER //
// ./src/resources/contractor/contractor.resource.js